import { createBrowserRouter } from 'react-router-dom';
import { AdminAuthGuard } from '../components/AdminAuthGuard';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { Layout } from '../components/Layout';
import { Dashboard } from '../pages/Dashboard';
import { OrganizationList } from '../pages/OrganizationList';
import { OrganizationDetail } from '../pages/OrganizationDetail';
import { Waitlist } from '../pages/Waitlist';
import { NotFound } from '../pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AdminAuthGuard>
        <Layout />
      </AdminAuthGuard>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: 'organizations',
        element: <OrganizationList />,
      },
      {
        path: 'organizations/:id',
        element: <OrganizationDetail />,
      },
      {
        path: 'waitlist',
        element: <Waitlist />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
